import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { toast } from 'components/Shared/Toast';
import clsx from 'clsx';
import { Card } from 'reactstrap';

export const Address = ({ backgroundColor, QRCode, address, ...props }) => {

    const { t } = useTranslation();

    const copyAddress = () => {
        navigator.clipboard.writeText(address);
        toast.success(t('common.copied_clipboard'));
    }

    return (
        <Card
            className={clsx('mt-2 rounded-lg p-4 text-white border-0', backgroundColor)}
            {...props}
        >
            <h5 className="">{t('blockchain.DepositAccount')}</h5>
            <div className="text-center">
                <div>
                    <img src={QRCode} alt="QRCode" className="rounded" height="125px" />
                </div>
                <div className="mt-3 pointer">
                    <span onClick={copyAddress}>{address} <i className="fas fa-copy"></i></span>
                </div>
            </div>
        </Card>
    );
};

Address.propTypes = {
    /**
     * ReceivedAmmount
     */
    QRCode: PropTypes.string,
    /**
     * SendAmount
     */
    address: PropTypes.string,
    /**
     * What background color to use
     */
    backgroundColor: PropTypes.string,
};
Address.defaultProps = {
    QRCode: '',
    address: '',
    backgroundColor: '#344e5c'
};


export default Address;